export const axiosTransformRequest = data => {
    let ret = "";
    for (let it in data) {
        ret +=
            encodeURIComponent(it) +
            "=" +
            encodeURIComponent(data[it]) +
            "&";
    }
    ret = ret.substring(0, ret.lastIndexOf("&"));
    return ret;
}

// 生成唯一ID
export function getUniqueId() {
    const s = [];
    let hexDigits = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    }
    s[14] = "4"
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
    s[8] = s[13] = s[18] = s[23] = "-"
    let uuid = s.join("")
    return uuid
}